/* ==========================================================
   JINS US — Airframe 2026 Landing Page
   File: assets/airframe-2026.js
   No jQuery. Vanilla JS only.
   ========================================================== */

(function () {
  'use strict';

  // ----------------------------------------------------------
  // 1. PAGE OPEN — fade in wrapper after short delay
  //    has-js added immediately so opacity:0 only applies when
  //    JS is present. CSS default is opacity:1 as fallback.
  // ----------------------------------------------------------
  // ----------------------------------------------------------
  // 0. NUKE DAWN WRAPPERS — strip all padding/max-width from
  //    every ancestor element that wraps #jins-airframe-2026
  // ----------------------------------------------------------
  (function nukeDawnWrappers() {
    var el = document.querySelector('#jins-airframe-2026');
    if (!el) return;
    var node = el.parentElement;
    while (node && node !== document.documentElement) {
      node.style.setProperty('max-width', '100%', 'important');
      node.style.setProperty('width', '100%', 'important');
      node.style.setProperty('padding-left', '0', 'important');
      node.style.setProperty('padding-right', '0', 'important');
      node.style.setProperty('margin-left', '0', 'important');
      node.style.setProperty('margin-right', '0', 'important');
      node = node.parentElement;
    }
    // Prevent horizontal scrollbar
    document.body.style.setProperty('overflow-x', 'hidden', 'important');
  })();

  const root = document.querySelector('#jins-airframe-2026');
  if (root) root.classList.add('has-js');

  window.addEventListener('load', function () {
    const root = document.querySelector('#jins-airframe-2026');
    if (!root) return;
    setTimeout(function () {
      root.classList.add('is-open');
    }, 600);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('#jins-airframe-2026');
    if (!root) return;

    // ----------------------------------------------------------
    // 2. LETTER WRAP — splits .af26-letter-area into per-char spans
    // ----------------------------------------------------------
    root.querySelectorAll('.af26-letter-area').forEach(function (el) {
      const text = el.textContent.trim();
      el.innerHTML = text.split('').map(function (ch) {
        return '<span class="af26-letter">' + (ch === ' ' ? '&nbsp;' : ch) + '</span>';
      }).join('');
    });

    // ----------------------------------------------------------
    // 3. INTERSECTION OBSERVER — AnimeA + AnimeB
    //    Replaces JP Waypoints.js. 1850ms delay mirrors JP timing.
    // ----------------------------------------------------------
    setTimeout(function () {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          if (el.classList.contains('af26-animeA')) el.classList.add('animated');
          if (el.classList.contains('af26-animeB')) el.classList.add('is-show');
          io.unobserve(el); // fire once only (down direction only, like JP)
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px -13% 0px' // equivalent to JP's 87% offset
      });

      root.querySelectorAll('.af26-animeA, .af26-animeB').forEach(function (el) {
        io.observe(el);
      });
    }, 1850);

    // ----------------------------------------------------------
    // 4. VIDEO — removed, hero is now a static <picture> tag
    // ----------------------------------------------------------
    // No video JS needed — PC/SP swap handled via <picture> srcset in HTML

    // ----------------------------------------------------------
    // 5. SMOOTH SCROLL — anchor links (replaces JP jQuery animate)
    //    Header height offset: 51px (matches JP value, adjust if Dawn header differs)
    // ----------------------------------------------------------
    const HEADER_H = 51;
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - HEADER_H + 10;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // ----------------------------------------------------------
    // 6. jt-slider — 3-way interlocked product item slider
    //    (image main + dot nav + SKU number)
    // ----------------------------------------------------------
    function initAfSlider(box) {
      const imgs  = box.querySelectorAll('.jt-af-main .jt-af-slide');
      const dots  = box.querySelectorAll('.jt-af-nav .jt-af-dot');
      const pnums = box.querySelectorAll('.jt-af-pnum .jt-af-slide');

      if (!imgs.length || !dots.length) return;

      function goTo(n) {
        imgs.forEach(function (el, i)  { el.classList.toggle('is-active', i === n); });
        pnums.forEach(function (el, i) { el.classList.toggle('is-active', i === n); });
        dots.forEach(function (d, i)   { d.classList.toggle('is-active', i === n); });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      goTo(0);
    }

    function initAllSliders(context) {
      (context || root).querySelectorAll('.jt-af-item-box').forEach(initAfSlider);
    }

    initAllSliders();

    // ----------------------------------------------------------
    // 7. HERO SECTION SLIDER — mobile 2-slide image cycle
    // ----------------------------------------------------------
    root.querySelectorAll('.jt-af-main-hero').forEach(function (heroSlider) {
      const slides = heroSlider.querySelectorAll('.jt-af-hero-slide');
      const section = heroSlider.closest('.af26-item');
      const dots = section ? section.querySelectorAll('.af26-hero-dot') : [];
      let cur = 0;

      function heroGo(n) {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
        dots.forEach(function (d, i)   { d.classList.toggle('is-active', i === n); });
        cur = n;
      }

      if (slides.length < 2) return;

      // Dot click only — no autoplay (matches JP behavior)
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          heroGo(i);
        });
      });
    });

    // ----------------------------------------------------------
    // 8. SEARCH FILTER — activate button when filter selected
    // ----------------------------------------------------------
    const searchBtn = root.querySelector('#af26-search-btn');

    function syncFilters(nameFrom, nameTo) {
      const checked = root.querySelector('input[name="' + nameFrom + '"]:checked');
      if (checked) {
        const mirror = root.querySelector('input[name="' + nameTo + '"][value="' + checked.value + '"]');
        if (mirror) mirror.checked = true;
      }
    }

    function updateSearchBtnState() {
      const hasGender = !!root.querySelector('input[name="af26-gender"]:checked');
      const hasShape  = !!root.querySelector('input[name="af26-shape"]:checked');
      if (searchBtn) searchBtn.classList.toggle('_active', hasGender || hasShape);
    }

    root.querySelectorAll('input[name="af26-gender"], input[name="af26-shape"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.name === 'af26-gender') syncFilters('af26-gender', 'af26-modal-gender');
        if (input.name === 'af26-shape')  syncFilters('af26-shape',  'af26-modal-shape');
        updateSearchBtnState();
      });
    });

    root.querySelectorAll('input[name="af26-modal-gender"], input[name="af26-modal-shape"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.name === 'af26-modal-gender') syncFilters('af26-modal-gender', 'af26-gender');
        if (input.name === 'af26-modal-shape')  syncFilters('af26-modal-shape',  'af26-shape');
      });
    });

    // ----------------------------------------------------------
    // 9. SEARCH — filter + results modal
    // ----------------------------------------------------------
    const resultModal  = root.querySelector('#af26-result-modal');
    const resultList   = root.querySelector('.af26-result-list');
    const resultCount  = root.querySelector('.af26-result-modal-count');
    const modalSearch  = root.querySelector('#af26-modal-search-btn');

    function cleanCloneForSlider(clone) {
      // Remove any stale is-active states before re-init
      clone.querySelectorAll('.jt-af-slide').forEach(function (s) { s.classList.remove('is-active'); });
      clone.querySelectorAll('.jt-af-dot').forEach(function (d) { d.classList.remove('is-active'); });
    }

    function runSearch() {
      if (!resultList) return;

      const gender = (root.querySelector('input[name="af26-gender"]:checked') || {}).value || null;
      const shape  = (root.querySelector('input[name="af26-shape"]:checked')  || {}).value || null;

      // Clear previous results
      resultList.innerHTML = '';

      let hits = 0;
      root.querySelectorAll('.jt-af-item-box').forEach(function (box) {
        const g = box.dataset.gender;
        const s = box.dataset.shape;
        const match = (!gender || g === gender) && (!shape || s === shape);
        if (!match) return;

        const clone = box.cloneNode(true);
        clone.removeAttribute('id');
        cleanCloneForSlider(clone);
        resultList.appendChild(clone);
        initAfSlider(clone);
        hits++;
      });

      if (resultCount) resultCount.textContent = hits + ' result' + (hits !== 1 ? 's' : '');
      if (resultModal) resultModal.style.display = 'block';
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        if (!searchBtn.classList.contains('_active')) return;
        runSearch();
      });
    }

    if (modalSearch) {
      modalSearch.addEventListener('click', function () {
        runSearch();
      });
    }

    // ----------------------------------------------------------
    // 10. MODAL — Zero-G Balance Design detail
    // ----------------------------------------------------------
    const detailModal = root.querySelector('#af26-detail-modal');

    root.querySelectorAll('.js-af26-detail-modal-open').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (detailModal) detailModal.style.display = 'block';
      });
    });

    root.querySelectorAll('.js-af26-detail-modal-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (detailModal) detailModal.style.display = 'none';
      });
    });

    // Close result modal
    root.querySelectorAll('.js-af26-result-modal-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (resultModal) resultModal.style.display = 'none';
      });
    });

    // Close any modal on overlay click
    [detailModal, resultModal].forEach(function (modal) {
      if (!modal) return;
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.style.display = 'none';
      });
    });

    // Close modals on ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      [detailModal, resultModal].forEach(function (modal) {
        if (modal) modal.style.display = 'none';
      });
    });

  }); // end DOMContentLoaded

})();
